/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { Container } from "unstated";
import { CountryList, LanguageList } from "../../api/basic/models/basic";
import { fetchCountries, fetchLanguages } from "../../api/basic/basicApi";
import { InvalidNetworkResponse } from "../../api/types";
import networkManager from "../../api/network";

interface Props {
  namespace: string;
}
interface State {
  countries: CountryList | null;
  isFetchingCountries: boolean;
  countriesError: Error | null;
  languages: LanguageList | null;
  isFetchingLanguages: boolean;
  languagesError: Error | null;
}

export default class BasicLogic extends Container<State> {
  private readonly props: Props;

  constructor(props: Props) {
    super();
    this.props = props;
    this.state = {
      countries: null,
      isFetchingCountries: false,
      countriesError: null,
      languages: null,
      isFetchingLanguages: false,
      languagesError: null,
    };
  }

  async fetchCountries() {
    const { namespace } = this.props;
    const { isFetchingCountries } = this.state;
    if (isFetchingCountries) return;
    this.setState({ isFetchingCountries: true });
    try {
      const network = networkManager.create();
      const { response, error } = await fetchCountries(network, {namespace});
      if (error) throw error;
      if (!response) throw new InvalidNetworkResponse();
      this.setState({
        countries: response.data,
      });
    } catch (error) {
      this.setState({ countriesError: error });
    } finally {
      this.setState({ isFetchingCountries: false });
    }
  }

  async fetchLanguages() {
    const { namespace } = this.props;
    const { isFetchingLanguages } = this.state;
    if (isFetchingLanguages) return;
    this.setState({ isFetchingLanguages: true });
    try {
      const network = networkManager.create();
      const { response, error } = await fetchLanguages(network, {namespace});
      if (error) throw error;
      if (!response) throw new InvalidNetworkResponse();
      this.setState({
        languages: response.data,
      });
    } catch (error) {
      this.setState({ languagesError: error });
    } finally {
      this.setState({ isFetchingLanguages: false });
    }
  }
}
